import ScrollingContainer from './ScrollingContainer'

export default ScrollingContainer



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/components/ScrollingContainer/index.js